import { Props_SnippetButtons } from './Buttons.props'
import React from 'react'

export const SnippetButtons = (props: Props_SnippetButtons) => {
    const {headingProps, repeatable_link} = props;

    const titleClass = headingProps.visibility.value === "visible" ? "snippet-image-and-text-headline__title" : "snippet-image-and-text-headline__title accessible-heading";

    return (
    <section className='snippet-buttons'>
        <div className="snippet-buttons__container">
            <h2 className={titleClass}>{headingProps.heading?.value}</h2>
            <div className="snippet-buttons__links">
            {repeatable_link?.map((link, index) => (
                <a key={index} className="snippet-buttons__link" href={link.linkhref?.value}>{link.linktext?.value}</a>
            ))}
            </div>
        </div>
    </section>
    )
}
